

































// <input type="checkbox" v-model="showLines" @change="changePointRadius">
// :library="{showLines: true}"
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  data() {
    return {
      showA1: true,
      showA2: true,
    };
  },
  // methods: {
  //   changePointRadius(event: any): void {
  //     const that: any = this;

  //     // @ts-ignore
  //     Chart.defaults.global.elements.point.radius = event.target.checked ? 0 : 1;

  //     that.forceRender = (that.forceRender + 1) % 5;
  //   },
  // },
  computed: {
    data(): any[] {
      const that: any = this;
      // data bind
      const populations: any = that.populations || [that.population];

      return populations.reduce((product: any[], p: any) => {
        if (that.showA1) {
          product.push({
            ...p.histogramData.a1,
            color: p.colorA1,
            name: `${p.name} A1`,
          });
        }
        if (that.showA2) {
          product.push({
            ...p.histogramData.a2,
            color: p.colorA2,
            name: `${p.name} A2`,
          });
        }
        return product;
      }, []);

    },
  },
})
export default class AllelesHistogram extends Vue {
  @Prop() private populations!: any[];
  @Prop() private population!: any;
}
